import ShoppingCartRow from './shopping-cart-row';

export default ShoppingCartRow;
